export default "skymp5-front/e48234a46f0ec154aaffe69b8d05a247.mp3";